import React from "react";
import { Card, CardBody, Col, Row, Badge } from "reactstrap";

const FinansIstatistikleri = ({ stats, user }) => {
  return (
    <Card className="shadow-sm border-0">
      {/* Yönetici Bilgisi */}
      <CardBody className="bg-primary-subtle rounded-top">
        <div className="d-flex">
          <div className="me-4">
            <i className="mdi mdi-shield-account text-primary h1" />
          </div>
          <div className="flex-grow-1">
            <h5 className="text-primary mb-1">{user?.AD_SOYAD || "Yönetici"}</h5>
            <p className="mb-1 text-muted small">{user?.Mail_Adress}</p>
            <Badge color="primary">Sistem Yöneticisi</Badge>
          </div>
        </div>
      </CardBody>

      {/* Özet İstatistikler */}
      <CardBody className="border-top">
        <Row>
          <Col sm="6" className="border-end">
            <p className="text-muted mb-1 font-size-12">Tamamlanan Ciro</p>
            <h5 className="text-success mb-0">
              {(stats.totalRevenue || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺
            </h5>
          </Col>
          <Col sm="6">
            <p className="text-muted mb-1 font-size-12">Bekleyen Ödemeler</p>
            <h5 className="text-warning mb-0">
              {(stats.pendingPayments || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺
            </h5>
          </Col>
        </Row>
      </CardBody>

      {/* Hızlı Sayılar */}
      <CardBody className="border-top">
        <Row className="text-center">
          <Col sm="4">
            <div className="font-size-22 text-success fw-bold">{stats.completedCount || 0}</div>
            <p className="text-muted mb-0 font-size-12">Tamamlanan</p>
          </Col>
          <Col sm="4" className="border-start border-end">
            <div className="font-size-22 text-warning fw-bold">{stats.pendingCount || 0}</div>
            <p className="text-muted mb-0 font-size-12">Beklemede</p>
          </Col>
          <Col sm="4">
            <div className="font-size-22 text-danger fw-bold">{stats.cancelledCount || 0}</div>
            <p className="text-muted mb-0 font-size-12">İptal</p>
          </Col>
        </Row>
      </CardBody>

      {/* Ödeme Tipi Dağılımı */}
      {stats.odemeTipleri && Object.keys(stats.odemeTipleri).length > 0 && (
        <CardBody className="border-top">
          <p className="text-muted mb-3 font-size-12 fw-bold text-uppercase">Ödeme Tiplerine Göre</p>
          {Object.entries(stats.odemeTipleri).map(([tip, tutar]) => (
            <div key={tip} className="d-flex justify-content-between align-items-center mb-2">
              <span className="font-size-13">{tip}</span>
              <span className="fw-bold font-size-13">
                {parseFloat(tutar).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺
              </span>
            </div>
          ))}
        </CardBody>
      )}
    </Card>
  );
};

export default FinansIstatistikleri;
